import React from 'react';

const LogoError = () => (
  <svg width="78.394516" height="121.39262" viewBox="0 0 78.394516 121.39262">
    <style>
      {'.a{fill:#FFF;}' +
        '.b{fill:#1D1E1C;}' +
        '.c{fill:#1D1E1C;opacity:0.2;}' +
        '.d{fill:#38A9B4;}' +
        '.e{fill:#070707;}' +
        '.f{fill:#197175;}' +
        '.g{fill:#0E5656;}' +
        '.h{fill:#332E27;}'}
    </style>
    <path
      d="M 48.5,53.5 C 48.3,60.7 43.4,66.3 37.3,66.2 31.2,66.1 26.4,60.2 26.6,53 c 0.2,-7.2 4.1,-11 10.2,-10.9 6.1,0.1 11.9,4.2 11.7,11.4 z"
      className="a"
    />
    <path d="m 36.4,41.4 c -3.2,0 -6.2,1.4 -8.5,4 -2.3,2.6 -2.4,4.1 -2.5,7.8 -0.1,3.7 1,7.1 3.2,9.8 2.2,2.7 5.1,4.1 8.3,4.2 1.4,0 2.7,-0.2 3.9,-0.7 4.6,-1.8 8,-6.8 8.1,-12.8 0.2,-7.8 -6.1,-12.2 -12.5,-12.3 z m 0.5,24.1 c -5.7,-0.1 -10.2,-5.6 -10,-12.4 0.1,-3.3 0,-4.4 2.1,-6.7 1.2,-1.3 2.6,-2.3 4,-2.9 1.1,-0.4 2.2,-0.6 3.3,-0.6 2.7,0 5.2,1.4 7,3.7 1.8,2.4 4,3.5 3.9,6.8 0,7 -4.6,12.2 -10.3,12.1 z" />
    <path
      d="m 36.7,57.1 c 1.2,3.1 0.5,5.9 -1.6,6.3 -2.1,0.4 -4.7,-1.8 -5.9,-4.9 -1.2,-3.1 -0.5,-5.9 1.6,-6.3 2.1,-0.4 4.7,1.8 5.9,4.9 z"
      className="b"
    />
    <path
      d="m 35.3,59.2 c 0.4,0.8 -0.1,1.7 -1,1.9 -0.9,0.2 -1.9,-0.4 -2.3,-1.2 -0.4,-0.8 0.1,-1.7 1,-1.9 0.9,-0.2 2,0.3 2.3,1.2 z"
      className="a"
    />
    <path
      d="m 58.3,54.9 c -0.2,6 -4.6,10.9 -9.9,10.8 -5.3,-0.1 -9.4,-5 -9.3,-11.1 0.2,-6 3.8,-9.7 9.1,-9.6 5.3,0.1 10.3,3.8 10.1,9.9 z"
      className="a"
    />
    <path d="m 47.9,44.3 c -2.8,0 -5.4,1.2 -7.5,3.4 -2,2.2 -2.4,3.9 -2.5,7.1 -0.1,3.1 0.9,6.1 2.8,8.3 1.9,2.3 4.5,3.5 7.3,3.6 1.2,0 2.4,-0.2 3.5,-0.6 4.1,-1.6 7.1,-5.9 7.2,-11 0.2,-6.6 -5,-10.7 -10.8,-10.8 z M 57.2,55 c -0.1,4.4 -2.7,8.1 -6.2,9.5 -0.9,0.4 -1.9,0.5 -2.9,0.5 -2.3,0 -4.5,-1.1 -6.1,-3 -1.6,-1.9 -2.5,-4.5 -2.4,-7.2 0.1,-4.4 1.9,-6.9 5.4,-8.2 0.9,-0.4 1.9,-0.5 2.9,-0.5 2.3,0 5,1 6.6,2.9 1.6,1.8 2.7,3.3 2.7,6 z" />
    <path
      d="m 48.3,58.2 c 1.2,2.5 0.6,4.9 -1.2,5.4 -1.9,0.4 -4.3,-1.3 -5.5,-3.9 -1.2,-2.5 -0.6,-4.9 1.2,-5.4 1.9,-0.4 4.4,1.4 5.5,3.9 z"
      className="b"
    />
    <path
      d="m 46.8,59.7 c 0.3,0.7 -0.1,1.5 -0.9,1.6 -0.8,0.2 -1.7,-0.3 -2,-1 -0.3,-0.7 0.1,-1.5 0.9,-1.6 0.8,-0.1 1.7,0.3 2,1 z"
      className="a"
    />
    <ellipse
      transform="rotate(-1.0509514)"
      cx="6.5862317"
      cy="115.13065"
      rx="6.2997999"
      ry="1.699946"
      className="c"
      style={{ strokeWidth: 0.999968 }}
    />
    <polygon
      points="86.7,271.1 76.4,267.6 86.8,298.6 85.3,298.7 74.6,265 87.7,270.1 "
      className="b"
      transform="translate(-66.7,-201.1)"
    />
    <polygon
      points="87.6,275.4 68.8,267.8 81.9,309.3 81.3,311.7 66.7,265.5 88.9,274.3 "
      className="b"
      transform="translate(-66.7,-201.1)"
    />
    <polygon
      points="78.3,281.9 100.2,315.7 98.2,315.8 75.2,280.2 94.5,281.8 95.1,283.1 "
      className="b"
      transform="translate(-66.7,-201.1)"
    />
    <polyline
      points="102.2 270.5 103 292.5 101.3 292.3 100.1 269.1 "
      className="b"
      transform="translate(-66.7,-201.1)"
    />
    <path
      d="m 34.5,91 c 0,0 -1.9,-3.3 -3.9,-1.1 -2,2.2 -0.8,5.1 -0.8,5.1 0,0 0.7,0.9 3,1 2.3,0.1 2.8,-0.1 3.2,-0.8 0.4,-0.7 0.3,-3.9 0.3,-3.9 z"
      className="b"
    />
    <path
      d="m 14.6,110.4 c 0.6,0.9 -4,-4.6 -6.7,-2.1 -3.3,3 -1.3,7 -1.3,7 0,0 1.1,1 4.8,0.9 4.8,-0.1 4.4,-1.3 4.7,-2.6 0.5,-2.1 -1.3,-6.4 -1.3,-6.4 z"
      className="b"
    />
    <path
      d="m 18.6,96.9 c 0,0 -0.9,-3.1 -3.1,-1.1 -1.3,1.2 -1.3,2.6 -1.2,3.6 0.1,0.8 0.7,1.4 1.5,1.5 0.5,0.1 1.1,0.2 2,0.2 3.2,-0.2 2.7,-1.2 2.7,-1.7 0,-2.7 -1,-4.3 -1,-4.3 z"
      className="b"
    />
    <path
      d="m 31.4,114.4 c 0,0 -2.9,-4.8 -6.2,-1.8 -3.3,3 -0.8,6.8 -0.8,6.8 0,0 1.1,1.2 4.9,1.1 4.9,-0.1 5.3,-2.6 4.9,-3.8 -1.3,-4.3 -2.1,-2.3 -2,-2.4 z"
      className="b"
    />
    <polygon
      points="117.2,280.8 134.7,270.2 130.2,297.8 132,297.8 136.9,267.1 116.8,278.3 "
      className="b"
      transform="translate(-66.7,-201.1)"
    />
    <polygon
      points="114.6,283.3 136.9,288.2 129.9,307.9 131.4,309.5 139.7,286.9 116.2,281.2 "
      className="b"
      transform="translate(-66.7,-201.1)"
    />
    <polygon
      points="110.8,292.4 107.9,316.1 109.7,316.1 112.8,290.9 102.8,283.4 102.3,285.4 "
      className="b"
      transform="translate(-66.7,-201.1)"
    />
    <polyline
      points="113.7 272 113.8 293.1 115.4 293.7 115.8 270.5 "
      className="b"
      transform="translate(-66.7,-201.1)"
    />
    <path
      d="m 48.8,92.4 c 0,0 1.5,-3.4 3.6,-1.3 2.1,2.1 1,5 1,5 0,0 -0.7,0.9 -2.9,1.1 -2.3,0.1 -2.8,0.1 -3.2,-0.6 -0.4,-0.7 -0.1,-5.9 -0.1,-5.9 z"
      className="b"
    />
    <path
      d="m 64.9,108.1 c 0,0 2.7,-5.5 6.1,-2.6 1.9,1.6 2.1,3.7 2,5.1 -0.1,1.3 -1.1,2.4 -2.4,2.7 -0.7,0.2 -1.6,0.3 -2.8,0.3 -4.8,0.1 -4.7,-1.7 -5.1,-2.9 -0.6,-2.1 0.6,-4.2 0.6,-4.2 z"
      className="b"
    />
    <path
      d="m 65.2,96.3 c 0,0 1.6,-3.9 3.8,-2 1.3,1.1 1.4,2.4 1.3,3.4 -0.1,0.9 -0.7,1.6 -1.6,1.8 -0.5,0.1 -1.1,0.2 -1.9,0.2 -3.2,0.1 -3.3,-0.7 -3.6,-1.5 -0.4,-1.4 0.9,-4.9 0.9,-4.9 z"
      className="b"
    />
    <path
      d="m 43.2,113.4 c 0,0 2.5,-4.6 5.9,-1.7 3.5,2.9 1.6,7 1.6,7 0,0 -1.1,1.2 -4.9,1.3 -4.9,0.1 -5.2,-2.4 -5.1,-3.7 0.7,-5.4 1.6,-4.1 1.6,-4.1 z"
      className="b"
    />
    <path
      d="M 49.4,49.4 C 61.5,58.2 61.1,65 53.2,75.9 47,84.5 37,87.2 27.2,80 17.4,72.8 18.7,63.8 24.9,55.3 c 6.2,-8.6 14.6,-13 24.5,-5.9 z"
      className="d"
    />
    <path
      d="M 53.9,76.7 C 50.6,81.2 46.4,84.1 41.7,85 36.7,86 31.4,84.6 26.5,81 17.3,74.3 16.4,65.3 23.9,55 31.5,44.5 40.7,42.4 49.8,49 c 4.9,3.6 9.3,8 9.9,13.2 0.4,4.7 -2.6,10 -5.8,14.5 z M 25.5,56.1 c -6.9,9.5 -6.2,17.4 2,23.4 8.8,6.4 18.3,4.8 24.7,-4 8.2,-11.3 7.4,-17.2 -3.5,-25.1 -10.3,-7.5 -18.3,-1 -23.2,5.7 z"
      className="b"
    />
    <ellipse
      transform="rotate(-1.0509514)"
      cx="25.006336"
      cy="119.6681"
      rx="6.9997773"
      ry="2.1999302"
      className="c"
      style={{ strokeWidth: 0.999968 }}
    />
    <ellipse
      transform="rotate(-1.0509514)"
      cx="14.670864"
      cy="99.676384"
      rx="4.0998697"
      ry="1.7999427"
      className="c"
      style={{ strokeWidth: 0.999968 }}
    />
    <ellipse
      transform="rotate(-1.0509514)"
      cx="29.960159"
      cy="94.956741"
      rx="4.5998535"
      ry="1.7999427"
      className="c"
      style={{ strokeWidth: 0.999968 }}
    />
    <ellipse
      transform="rotate(-1.0509514)"
      cx="70.023994"
      cy="113.59354"
      rx="6.2997999"
      ry="1.699946"
      className="c"
      style={{ strokeWidth: 0.999968 }}
    />
    <ellipse
      transform="rotate(-1.0509514)"
      cx="48.214378"
      cy="119.39447"
      rx="6.9997773"
      ry="2.1999302"
      className="c"
      style={{ strokeWidth: 0.999968 }}
    />
    <ellipse
      transform="rotate(-1.0509514)"
      cx="68.082924"
      cy="99.455231"
      rx="4.0998697"
      ry="1.7999427"
      className="c"
      style={{ strokeWidth: 0.999968 }}
    />
    <ellipse
      transform="rotate(-1.0509514)"
      cx="51.929268"
      cy="96.859306"
      rx="4.5998535"
      ry="1.7999427"
      className="c"
      style={{ strokeWidth: 0.999968 }}
    />
    <rect
      x="43.179913"
      y="-73.94606"
      transform="rotate(123.93161)"
      width="0.89999515"
      height="5.4999704"
      className="e"
      style={{ strokeWidth: 0.999995 }}
    />
    <rect
      x="82.879547"
      y="-7.8476582"
      transform="rotate(68.942332)"
      width="0.89998138"
      height="5.4998865"
      className="e"
      style={{ strokeWidth: 0.999979 }}
    />
    <path d="m 42.8,19.3 c 0,-1.7 0.3,-2.9 0.9,-3.8 0.6,-0.8 1.7,-1.8 3.2,-2.9 0.8,-0.5 1.4,-1.1 1.9,-1.9 0.5,-0.7 0.7,-1.6 0.7,-2.6 0,-1 -0.3,-1.8 -0.8,-2.4 C 48.2,5.1 47.4,4.8 46.4,4.8 45.6,4.8 44.9,5 44.4,5.5 43.9,6 43.6,6.7 43.5,7.7 h -6 V 7.6 c 0,-2.5 0.8,-4.4 2.4,-5.7 1.6,-1.3 3.8,-1.9 6.5,-1.9 2.9,0 5.1,0.7 6.8,2.2 1.7,1.5 2.5,3.4 2.5,5.9 0,1.5 -0.5,2.9 -1.4,4.2 -0.9,1.3 -2,2.3 -3.4,3 -0.8,0.5 -1.3,1.1 -1.6,1.6 -0.3,0.6 -0.4,1.4 -0.4,2.4 z m 6.1,7.6 H 42.8 V 22 h 6.1 z" />
    <path d="m 64.6,29.7 c 0.4,-1.1 1,-1.9 1.6,-2.4 0.6,-0.4 1.6,-0.8 3,-1.2 0.7,-0.1 1.3,-0.4 1.8,-0.8 0.5,-0.4 0.9,-0.9 1.2,-1.6 0.3,-0.7 0.3,-1.3 0.1,-1.9 -0.2,-0.6 -0.7,-1 -1.4,-1.2 -0.6,-0.2 -1.1,-0.2 -1.6,0 -0.5,0.2 -0.9,0.6 -1.2,1.3 L 64,20.3 v -0.1 c 0.6,-1.7 1.7,-2.8 3.1,-3.3 1.4,-0.4 3.1,-0.3 4.9,0.4 2,0.7 3.3,1.8 4.1,3.3 0.8,1.4 0.8,3 0.2,4.7 -0.4,1 -1.1,1.9 -2,2.5 -0.9,0.6 -2,1 -3.1,1.2 -0.7,0.1 -1.2,0.4 -1.5,0.7 -0.3,0.3 -0.6,0.8 -0.9,1.5 z m 2.2,6.8 -4.2,-1.6 1.3,-3.4 4.2,1.6 z" />
    <path d="m 27,33.1 c -0.5,-0.7 -0.8,-1.4 -0.8,-1.9 0,-0.5 0.1,-1.3 0.5,-2.3 0.2,-0.5 0.3,-0.9 0.2,-1.4 0,-0.5 -0.2,-0.9 -0.5,-1.3 -0.3,-0.4 -0.7,-0.7 -1.1,-0.8 -0.4,-0.1 -0.8,0 -1.3,0.3 -0.3,0.3 -0.6,0.6 -0.6,1 -0.1,0.4 0,0.8 0.3,1.2 l -2.5,1.9 v 0 c -0.8,-1.1 -1.1,-2.1 -0.8,-3.2 0.3,-1.1 1,-2 2.2,-2.8 1.2,-0.9 2.4,-1.3 3.6,-1.2 1.2,0.1 2.1,0.7 2.9,1.7 0.5,0.6 0.7,1.4 0.7,2.2 0,0.8 -0.2,1.6 -0.5,2.4 -0.2,0.5 -0.2,0.9 -0.2,1.2 0.1,0.3 0.3,0.7 0.6,1.1 z m 5,1.3 -2.6,1.9 -1.5,-2.1 2.6,-1.9 z" />
  </svg>
);

export default LogoError;
